

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapWapper from './map/MapWapper';
import MapShare from './map/MapShare';
import Factory from '@/views/emap/gis/Factory';
import { mapService } from '../../api/installService';
import publishObjectPath from '@/util/configRegistry';

@Component({
  name: 'MapLayout',
  components: {},
  mixins: [],
})
export default class MapLayout extends Vue {
  @Injectable() public container!: Container;
  private dimension: string = '2d';

  private longitude: string = '0';
  private latitude: string = '0';

  constructor() {
    super();
  }
  public async mounted() {
    const targetId: any = 'map';
    const mapShare: any = await this.initMap(targetId);
    this.initComponents(mapShare);
    // 地图加载完成，全局通知
    const notify = this.container.resolve('notify');
    notify.emit(`map-ready-${targetId}`, mapShare);

    notify.on(
      'dimension-changed',
      (d: any) => {
        this.dimension = d;
      },
      this,
    );
    // this.dimension = '3d'
    this.getComponent().on('mousePosition', this.onMousePosition, this);
  }

  private close3D() {
    G.viewer.scene.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(127.49826729232066, 50.21115124698365, 4580.270182725802),
      duration: 1.5,
      orientation: {
        // heading:0.7272,
        pitch: Cesium.Math.toRadians(-90),
        roll: 0,
      },
      complete: () => {
        setTimeout(() => {
          this.$store.state.mapModule.show3D = false;
          $('.cesium-viewer').remove();
          // G.viewer = null;
        }, 100);
      },
    });
  }

  private beforeDestroy() {
    this.getComponent().off('mousePosition', this.onMousePosition, this);
  }

  private onMousePosition(button: any, shift: any, screenX: any, screenY: any, mapX: any, mapY: any, handle: any) {
    this.longitude = mapX.toFixed(4);
    this.latitude = mapY.toFixed(4);
  }

  private getComponent() {
    let component = null;
    const factory = this.container.resolve('mapShare').comFactory;
    if (factory) {
      component = factory.getComponent('Toolbar').GISToolComponent.mousePosition;
    }
    return component;
  }

  // 按钮点击事件触发前
  private beforeToolbarClickHandle(item: any, params: any) {
    // 取消测量
    params.toolComponent.cancelMeasure();
    //
    params.context.isShowThematic = false;
  }
  // 按钮点击事件触发后
  private afterToolbarClickHandle(item: any, params: any) {
    //
  }

  private async initMap(targetId: any, globeId: any = null) {
    return new Promise(async (resolve, reject) => {
      const mapService: any = this.container.resolve('mapService');
      // 地图配置
      const mapConfig = await mapService.getMapConfig();
      if (!globeId) {
        mapConfig.switchLayers = mapConfig.switchLayers.filter((item: any) => {
          return item.name !== '三维底图';
        });
      }
      const mapWapper: MapWapper = new MapWapper({
        targetId,
        globeId,
        mapConfig,
        serviceConfig: publishObjectPath.value,
      });
      mapWapper.init();
      // 符号配置
      const symbolConfig = await mapService.getSymbolConfig();
      mapWapper.setOptions({
        symbolConfig,
      });
      mapWapper.initComponents();
      // 更新共享变量
      const mapShare: MapShare = this.container.resolve('mapShare');
      mapShare.setMapWapper(mapWapper);
      mapShare.setMapConfig(mapConfig);
      mapShare.setSymbolConfig(symbolConfig);
      resolve(mapShare);
    });
  }

  private initComponents(mapShare: MapShare) {
    return new Promise((resolve, reject) => {
      const map = mapShare.getMapWapper().getMap();
      const map3d = mapShare.getMapWapper().getMap3D();
      // GIS 组件
      const factory: Factory = new Factory({
        map,
        basicComponents: mapShare.getMapWapper().getComponents(),
        serviceConfig: publishObjectPath.value,
        symbolConfig: mapShare.getSymbolConfig(),
        map3d,
      });
      // 初始化所有组件
      factory.createComponents();
      const _mapShare = this.container.resolve('mapShare');
      _mapShare.comFactory = factory;
      map.on('mousemove', this.onMousePosition);
    });
  }
}
